import placeholder from "@/assets/images/common/placeholder.svg"
import {
  useStyle 
} from "@/classify"
import Image from "next/image"
import Shimmer from "../Shimmer"
import defaultClasses from "./item.module.css"

const GalleryItemShimmer = (props) => {
  const classes = useStyle(defaultClasses, props.classes)


  return (
    <div className={classes.root} aria-live='polite' aria-busy='true'>
      <Shimmer key='product-image'
        classes={{
          root_rectangle: classes.shimmerRoot
        }}
      >
        <Image
          alt='Placeholder for gallery item image'
          src={placeholder}
        />
      </Shimmer>
      <Shimmer
        width='100%'
        className={classes.name}
        key='product-name'
      />
      <Shimmer width={3} key='product-price' />
    </div>
  )
}

export default GalleryItemShimmer
